$(function() {

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin, TextPlugin);
	
	// Title Slide Down
	
	// Heading Slide Out
	gsap.fromTo('.hero-back', {
		y: -500
	}, {
		y: 0, 
		duration: 1.2,
		ease: Linear.easeNone
	});
	
	gsap.fromTo(".hero-copy", {
		color: "#0367a5"	
	}, {
		color: "#fff",
		ease: Linear.easeNone,
		duration: 2,
		delay: 1
	});
	

	// Heading Slide Outs
	gsap.fromTo($('.head1 .head1-fill'), {
		x: -1200
	}, {
		duration: 1.5,
		ease: Linear.easeNone,
		x: 0,
		scrollTrigger: {
			trigger: ".scroll-head",
			start: "top bottom",
			toggleActions: "play none none reset"
		}
	});
	
	gsap.fromTo($('.head1-fill'), {
		borderToprightRadius: "120px",
		borderBottomrightRadius: "120px"
	}, {
		duration: 1,
		delay: 1.3,
		ease: Linear.easeNone,
		borderTopRightRadius: "0px",
		borderBottomRightRadius: "0px",
		scrollTrigger: {
			trigger: ".scroll-head",
			start: "top bottom",
			toggleActions: "play none none reset"
		}
	});
	
	
	gsap.fromTo($('.head2 .head2-fill'), {
		x: -1200
	}, {
		duration: 1.5,
		ease: Linear.easeNone,
		x: 0,
		scrollTrigger: {
			trigger: ".scroll-head2",
			start: "top bottom",
			toggleActions: "play none none reset"
		}
	});
	
	gsap.fromTo($('.head2-fill'), {
		borderToprightRadius: "120px",
		borderBottomrightRadius: "120px"
	}, {
		duration: 1,
		delay: 1.3,
		ease: Linear.easeNone,
		borderTopRightRadius: "0px",
		borderBottomRightRadius: "0px",
		scrollTrigger: {
			trigger: ".scroll-head2",
			start: "top bottom",
			toggleActions: "play none none reset"
		}
	});
	
	gsap.fromTo($('.head3 .head3-fill'), {
		x: -1200
	}, {
		duration: 1.5,
		ease: Linear.easeNone,
		x: 0,
		scrollTrigger: {
			trigger: ".scroll-head3",
			start: "top bottom",
			toggleActions: "play none none reset"
		}
	});
	
	gsap.fromTo($('.head3-fill'), {
		borderToprightRadius: "120px",
		borderBottomrightRadius: "120px"
	}, {
		duration: 1,
		delay: 1.3,
		ease: Linear.easeNone,
		borderTopRightRadius: "0px",
		borderBottomRightRadius: "0px",
		scrollTrigger: {
			trigger: ".scroll-head3",
			start: "top bottom",
			toggleActions: "play none none reset"
		}
	});
	
	gsap.fromTo($('.head4 .head4-fill'), {
		x: -1200
	}, {
		duration: 1.5,
		ease: Linear.easeNone,
		x: 0,
		scrollTrigger: {
			trigger: ".scroll-head4",
			start: "top bottom",
			toggleActions: "play none none reset"
		}
	});
	gsap.fromTo($('.head4-fill'), {
		borderToprightRadius: "120px",
		borderBottomrightRadius: "120px"
	}, {
		duration: 1,
		delay: 1.3,
		ease: Linear.easeNone,
		borderTopRightRadius: "0px",
		borderBottomRightRadius: "0px",
		scrollTrigger: {
			trigger: ".scroll-head4",
			start: "top bottom",
			toggleActions: "play none none reset"
		}
	});
	
	gsap.fromTo($('.head5 .head5-fill'), {
		x: -1200
	}, {
		duration: 1.5,
		ease: Linear.easeNone,
		x: 0,
		scrollTrigger: {
			trigger: ".scroll-head5",
			start: "top bottom",
			toggleActions: "play none none reset"
		}
	});
	
	gsap.fromTo($('.head5-fill'), {
		borderToprightRadius: "120px",
		borderBottomrightRadius: "120px"
	}, {
		duration: 1,
		delay: 1.3,
		ease: Linear.easeNone,
		borderTopRightRadius: "0px",
		borderBottomRightRadius: "0px",
		scrollTrigger: {
			trigger: ".scroll-head5",
			start: "top bottom",
			toggleActions: "play none none reset"
		}
	});
	
	gsap.fromTo($('.head6 .head6-fill'), {
		x: -1200
	}, {
		duration: 1.5,
		ease: Linear.easeNone,
		x: 0,
		scrollTrigger: {
			trigger: ".scroll-head6",
			start: "top bottom",
			toggleActions: "play none none reset"
		}
	});
	
	gsap.fromTo($('.head6-fill'), {
		borderToprightRadius: "120px",
		borderBottomrightRadius: "120px"
	}, {
		duration: 1,
		delay: 1.3,
		ease: Linear.easeNone,
		borderTopRightRadius: "0px",
		borderBottomRightRadius: "0px",
		scrollTrigger: {
			trigger: ".scroll-head6",
			start: "top bottom",
			toggleActions: "play none none reset"
		}
	});
	
	gsap.fromTo($('.head7 .head7-fill'), {
		x: -1200
	}, {
		duration: 1.5,
		ease: Linear.easeNone,
		x: 0,
		scrollTrigger: {
			trigger: ".scroll-head7",
			start: "top bottom",
			toggleActions: "play none none reset"
		}
	});
	gsap.fromTo($('.head7-fill'), {
		borderToprightRadius: "120px",
		borderBottomrightRadius: "120px"
	}, {
		duration: 1,
		delay: 1.3,
		ease: Linear.easeNone,
		borderTopRightRadius: "0px",
		borderBottomRightRadius: "0px",
		scrollTrigger: {
			trigger: ".scroll-head7",
			start: "top bottom",
			toggleActions: "play none none reset"
		}
	});
	
	//Scroll Dot
	gsap.fromTo($('.dot-wrapper'), {
		y: 0
	}, {
		y:775,
		scrollTrigger: {
			trigger: ".scroll-container",
			start: "top top",
			end: "bottom bottom",
			scrub: 1,
			pin: ".scroll-animate",
			toggleActions: "play none none reset"
		},
	});
	
	gsap.to(".dot", {
		  scale: 1.4,
		  opacity: .6,
		  duration: 1,
		  stagger: {
			  each: 0.75,
			  repeat: -1
		  }
		});
	
	//Card Fade In
	gsap.defaults({ease: "power3"});
	gsap.set(".grid-contents", {y: 25});
	
	ScrollTrigger.batch(".grid-contents", {
		onEnter: batch => gsap.to(batch, {opacity: 1, y: 0, stagger: {each: 0.2, grid: [1, 4]}, overwrite: true}),
		onLeave: batch => gsap.set(batch, {opacity: 0.2, y: -25, overwrite: true}),
		onEnterBack: batch => gsap.to(batch, {opacity: 1, y: 0, stagger: 0.2, overwrite: true}),
		onLeaveBack: batch => gsap.set(batch, {opacity: 0.2, y: 25, overwrite: true})
	});
	
	ScrollTrigger.addEventListener("refreshInit", () => gsap.set(".grid-contents", {y: 0}));
	

	// Number animations
	var per1Start = { val: 0 };
	var per1End = 70;
	gsap.to(per1Start, {
		val: per1End,
		roundProps: "val",
		onUpdate: function() {
			var n = per1Start.val.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
			$('.per1').html(n)
		},
		onStart: function() {
			gsap.fromTo($('.percent1-wrapper'), {
				color: "#FFF"
			}, {
				ease: Linear.easeNone,
				duration: 2.5,
				delay: 1,
				color: "#f5a623"
			});
		},
		duration: 6,
		scrollTrigger: {
			trigger: ".percent1-wrapper",
			start: "bottom bottom",
			toggleActions: "play none none reset"
		}
	});
	
	var mil1Start = { val: 0 };
	var mil1End = 51;
	gsap.to(mil1Start, {
		val: mil1End,
		roundProps: "val",
		onUpdate: function() {
			var n = mil1Start.val.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
			$('.mil1').html(n)
		},
		onStart: function() {
			gsap.fromTo($('.mil1-wrapper'), {
				color: "#FFF"
			}, {
				ease: Linear.easeNone,
				duration: 2.5,
				delay: 1,
				color: "#f5a623"
			});
		},
		duration: 6,
		scrollTrigger: {
			trigger: ".mil1-wrapper",
			start: "bottom bottom",
			toggleActions: "play none none reset"
		}
	});
	
	var per2Start = { val: 0 };
	var per2End = 16;
	gsap.to(per2Start, {
		val: per2End,
		roundProps: "val",
		onUpdate: function() {
			var n = per2Start.val.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
			$('.per2').html(n)
		},
		onStart: function() {
			gsap.fromTo($('.percent2-wrapper'), {
				color: "#FFF"
			}, {
				ease: Linear.easeNone,
				duration: 1.5,
				delay: 1,
				color: "#f5a623"
			});
		},
		duration: 4,
		delay: 1,
		scrollTrigger: {
			trigger: ".percent2-wrapper",
			start: "bottom bottom",
			toggleActions: "play none none reset"
		}
	});
	
	// Lightning
	gsap.to("#Bolt-1", {
		  scale: .8,
		  ease: 'elastic',
		  yoyo: true,
		  duration: .5,
		  stagger: {
		  	each: 1,
		  	repeat: -1
		  }
	});
	gsap.to("#Bolt-2", {
		  scale: .9,
		  ease: 'elastic',
		  yoyo: true,
		  duration: 1,
		  stagger: {
			  each: 0.75,
			  repeat: -1
		  }
	});
	gsap.to("#Bolt-3", {
		  scale: .85,
		  ease: 'elastic',
		  yoyo: true,
		  duration: .75,
		  stagger: {
			  each: 0.5,
			  repeat: -1
		  }
	});
	gsap.to("#Fill-184", {
		  opacity: .35,
		  duration: .5,
		  ease: 'power1',
		  stagger: {
			  each: 1,
			  repeat: -1
		  }
	});
	gsap.to("#Fill-175", {
		  opacity: .5,
		  duration: .75,
		  ease: 'power1',
		  stagger: {
			  each: .75,
			  repeat: -1
		  }
	});
	gsap.to("#Fill-187", {
		  opacity: .2,
		  duration: 1,
		  ease: 'power1',
		  stagger: {
			  each: .5,
			  repeat: -1
		  }
	});
	
	// Help Section Animations

	ScrollTrigger.matchMedia({
		"(min-width: 767.98px)": function() {
		  gsap.fromTo($('.help-img1'), {
			  xPercent: 100
		  }, {
			  duration: 1.5,
			  ease: Linear.easeNone,
			  delay: 1,
			  xPercent: 0,
			  scrollTrigger: {
				  trigger: ".help1-trigger",
				  start: "bottom bottom",
				  toggleActions: "play none none none"
			  },
			  stagger: {
				  each: .5
			  }
		  });
		}
	});
	ScrollTrigger.matchMedia({
		"(min-width: 767.98px)": function() {
			gsap.fromTo($('.help-content1'), {
				xPercent: -50,
				opacity: 0
			}, {
				duration: 1.5,
				ease: Linear.easeNone,
				opacity: 1,
				delay: 1.5,
				xPercent: 0,
				scrollTrigger: {
					trigger: ".help1-trigger",
					start: "bottom bottom",
					toggleActions: "play none none none"
				},
				stagger: {
					each: .5
				}
			});
		}
	});
	gsap.fromTo($('.help-circle1'), {
		opacity: 1
		}, {
			duration: 2,
			ease: Linear.easeNone,
			opacity: 0,
			delay: 1.5,
			scrollTrigger: {
				trigger: ".help1-trigger",
				start: "bottom bottom",
				toggleActions: "play none none none"
			},
			stagger: {
				each: .5
			}
	});
	gsap.fromTo($('.circle-copy1'), {
		opacity: 1
		}, {
			duration: 2,
			ease: Linear.easeNone,
			opacity: 0,
			delay: 1.5,
			scrollTrigger: {
				trigger: ".help1-trigger",
				start: "bottom bottom",
				toggleActions: "play none none none"
			},
			stagger: {
				each: .5
			}
	});
	ScrollTrigger.matchMedia({
		"(min-width: 767.98px)": function() {
			gsap.fromTo($('.help-img2'), {
				xPercent: 100
			}, {
				duration: 1.5,
				ease: Linear.easeNone,
				delay: 1,
				xPercent: 0,
				scrollTrigger: {
					trigger: ".help2-trigger",
					start: "bottom bottom",
					toggleActions: "play none none none"
				},
				stagger: {
					each: .5
				}
			});
		}
	});
	ScrollTrigger.matchMedia({
		"(min-width: 767.98px)": function() {
			gsap.fromTo($('.help-content2'), {
				xPercent: -50,
				opacity: 0
			}, {
				duration: 1.5,
				ease: Linear.easeNone,
				opacity: 1,
				delay: 1.5,
				xPercent: 0,
				scrollTrigger: {
					trigger: ".help2-trigger",
					start: "bottom bottom",
					toggleActions: "play none none none"
				},
				stagger: {
					each: .5
				}
			});
		}
	});
	gsap.fromTo($('.help-circle2'), {
		opacity: 1
		}, {
			duration: 2,
			ease: Linear.easeNone,
			opacity: 0,
			delay: 1.5,
			scrollTrigger: {
				trigger: ".help2-trigger",
				start: "bottom bottom",
				toggleActions: "play none none none"
			},
			stagger: {
				each: .5
			}
	});
	gsap.fromTo($('.circle-copy2'), {
		opacity: 1
		}, {
			duration: 2,
			ease: Linear.easeNone,
			opacity: 0,
			delay: 1.5,
			scrollTrigger: {
				trigger: ".help2-trigger",
				start: "bottom bottom",
				toggleActions: "play none none none"
			},
			stagger: {
				each: .5
			}
	});
	ScrollTrigger.matchMedia({
		"(min-width: 767.98px)": function() {
			gsap.fromTo($('.help-img3'), {
				xPercent: 100
			}, {
				duration: 1.5,
				ease: Linear.easeNone,
				delay: 1,
				xPercent: 0,
				scrollTrigger: {
					trigger: ".help3-trigger",
					start: "bottom bottom",
					toggleActions: "play none none none"
				},
				stagger: {
					each: .5
				}
			});
		}
	});
	ScrollTrigger.matchMedia({
		"(min-width: 767.98px)": function() {
			gsap.fromTo($('.help-content3'), {
				xPercent: -50,
				opacity: 0
			}, {
				duration: 1.5,
				ease: Linear.easeNone,
				opacity: 1,
				delay: 1.5,
				xPercent: 0,
				scrollTrigger: {
					trigger: ".help3-trigger",
					start: "bottom bottom",
					toggleActions: "play none none none"
				},
				stagger: {
					each: .5
				}
			});
		}
	});
	gsap.fromTo($('.help-circle3'), {
		opacity: 1
		}, {
			duration: 2,
			ease: Linear.easeNone,
			opacity: 0,
			delay: 1.5,
			scrollTrigger: {
				trigger: ".help3-trigger",
				start: "bottom bottom",
				toggleActions: "play none none none"
			},
			stagger: {
				each: .5
			}
	});
	gsap.fromTo($('.circle-copy3'), {
		opacity: 1
		}, {
			duration: 2,
			ease: Linear.easeNone,
			opacity: 0,
			delay: 1.5,
			scrollTrigger: {
				trigger: ".help3-trigger",
				start: "bottom bottom",
				toggleActions: "play none none none"
			},
			stagger: {
				each: .5
			}
	});

	// Accordion
	
	const angle1 = gsap.timeline({paused: false});
	angle1.to($('.angle1'), 0.5, {
		ease:Linear.easeNone,
		repeat: -1, 
		y: 5,
		yoyo: true,
		transformOrigin: "center center"
	});
	
	// $('#headingOne').hover(function () {
	// 	angle1.pause();
	// });
	
	$('#headingOne').click(function () {
		angle1.pause();
	});
	
	const angle2 = gsap.timeline({paused: false});
	angle2.to($('.angle2'), {
		ease:Linear.easeNone,
		repeat: -1, 
		y: 5,
		yoyo: true,
		transformOrigin: "center center"
	});
	
	// $('#headingTwo').hover(function () {
	// 	angle2.pause();
	// });
	
	$('#headingTwo').click(function () {
		angle2.pause();
	});
	
	const angle3 = gsap.timeline({paused: false});
	angle3.to($('.angle3'), 0.5, {
		ease:Linear.easeNone,
		repeat: -1, 
		y: 5,
		yoyo: true,
		transformOrigin: "center center"
	});
	
	// $('#headingThree').hover(function () {
	// 	angle3.pause();
	// });
	
	$('#headingThree').click(function () {
		angle3.pause();
	});
	
	const angle4 = gsap.timeline({paused: false});
	angle4.to($('.angle4'), 0.5, {
		ease:Linear.easeNone,
		repeat: -1, 
		y: 5,
		yoyo: true,
		transformOrigin: "center center"
	});
	
	// $('#headingFour').hover(function () {
	// 	angle4.pause();
	// });
	
	$('#headingFour').click(function () {
		angle4.pause();
	});
	
	const angle5 = gsap.timeline({paused: false});
	angle5.to($('.angle5'), 0.5, {
		ease:Linear.easeNone,
		repeat: -1, 
		y: 5,
		yoyo: true,
		transformOrigin: "center center"
	});
	
	// $('#headingFive').hover(function () {
	// 	angle5.pause();
	// });
	
	$('#headingFive').click(function () {
		angle5.pause();
	});
	
	const angle6 = gsap.timeline({paused: false});
	angle6.to($('.angle6'), 0.5, {
		ease:Linear.easeNone,
		repeat: -1, 
		y: 5,
		yoyo: true,
		transformOrigin: "center center"
	});
	
	// $('#headingSix').hover(function () {
	// 	angle6.pause();
	// });
	
	$('#headingSix').click(function () {
		angle6.pause();
	});
	
	// Icons
	
	const icon_animate1 = gsap.timeline({paused: true});
	icon_animate1.fromTo($('.glass-icon'), {
		scale: 0
		}, {
			scale: 1,
			ease: 'elastic',
			duration: 1.5,
			transformOrigin: 'center',
			delay: 0.75
	});
	$('#headingOne').click(function () {
		icon_animate1.restart();
	});
	
	const icon_animate2 = gsap.timeline({paused: true});
	icon_animate2.fromTo($('.stopwatch-icon'), {
		x: -100
		}, {
			x:0,
			ease: 'elastic',
			duration: 5,
			delay: 0.75
	});
	$('#headingTwo').click(function () {
		icon_animate2.restart();
	});
	
	const icon_animate3 = gsap.timeline({paused: true});
	icon_animate3.fromTo($('.classroom-icon'), {
		opacity: 0
		}, {
			opacity: 1,
			yoyo: true,
			duration: 1.5,
			delay: 0.75
	});	
	$('#headingThree').click(function () {
		icon_animate3.restart();
	});
	
	const icon_animate4 = gsap.timeline({paused: true});
	icon_animate4.to('.rewind-icon', {
			ease: Linear.easeNone, 
			rotation:360, 
			duration: 4,
			transformOrigin: "center center",
			delay: 0.75
	});
	$('#headingFour').click(function () {
		icon_animate4.restart();
	});
	
	const icon_animate5 = gsap.timeline({paused: true});
	icon_animate5.fromTo($('.thought-icon'), {
		opacity: 0
		}, {
			opacity: 1,
			yoyo: true,
			duration: 1.5,
			delay: 1
	});
	$('#headingFive').click(function () {
		icon_animate5.restart();
	});
	
	const icon_animate6 = gsap.timeline({paused: true});
	icon_animate6.fromTo($('.bubble'), {
		opacity: 0
		}, {
			opacity: 1,
			ease: Linear.easeNone, 
			duration: 2,
			delay: .5
	});
	$('#headingSix').click(function () {
		icon_animate6.restart();
	});
	
});
